<template>
  <CCardBody>
    <CInputRadioGroup
      class="w-100 d-flex justify-content-between font-weight-bold"
      color="primary"
      custom
      :checked="check"
      :options="options"
      @update:checked="changePayPeriodToggle"
    />
    <CRow>
      <CCol class="ml-4 text-gray-500">Save up to 10% with this payment method</CCol>
      <CCol class="pl-3"></CCol>
    </CRow>
  </CCardBody>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PayPeriod',
  data() {
    return {}
  },

  computed: {
    check() {
      const value = this.$store.state.backOffice.steps.paymentPeriod == 1 ? 'monthly' : 'annualPayment'
      return this.options.filter((item) => item.value == value)[0].value
    },

    options() {
      return [
        {
          value: 'annualPayment',
          label: this.$t(`manageplan.component.card.subTotal.annualPayment`),
        },
        {
          value: 'monthly',
          label: this.$t(`manageplan.component.card.subTotal.monthly`),
        },
      ]
    },
  },

  methods: {
    changePayPeriodToggle(value) {
      const _value = value == 'annualPayment' ? 3 : 1
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'paymentPeriod', data: _value })
    },
  },
}
</script>

<style lang="scss">
.c-switch-primary .c-switch-slider {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}

.switchPeriod {
  min-width: 400px;
  .text {
    word-break: break-word;
  }
}
</style>
